"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFailure = exports.updateSuccess = exports.updateRequest = void 0;
const types = require("./types");
const updateRequest = (pluginName) => ({
    pluginName,
    type: types.UPDATE_REQUEST
});
exports.updateRequest = updateRequest;
const updateSuccess = (pluginName, data = {}) => ({
    pluginName,
    data,
    type: types.UPDATE_SUCCESS
});
exports.updateSuccess = updateSuccess;
const updateFailure = (pluginName, errorMessage) => ({
    pluginName,
    errorMessage,
    type: types.UPDATE_FAILURE
});
exports.updateFailure = updateFailure;
//# sourceMappingURL=actions.js.map